const WLPowerfulFormBuilder = {
  init: function(form) {
    const url = new URL(window.location.href);
    const requiredText = document.documentElement.lang === 'ja' ? '必須' : 'Required';

    const requiredLogin = document.querySelector('.globo-form.globo_required_login_form');
    if(requiredLogin) {
      location.href = '/account/login?checkout_url=' + encodeURIComponent(location.href);
    }

    // 「必須」の置き換え
    this.replaceRequired(form, requiredText);

    // メールアドレスの確認
    const mailAddress = form.querySelector('.unico-pfb-mail input[type="text"]');
    const confirmMailAddress = form.querySelector('.unico-pfb-mail-confirm input[type="text"]');
    if (mailAddress && confirmMailAddress) {
      this.checkMailAddress(form);
    }

    // 送信ボタンの下に表示する要素がある場合
    this.underButton(form);
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.globo-form-app .next') && !event.target.closest('.globo-form-app .previous')) return;
      this.underButton(form);
    })

    // コーディネート相談申込フォーム
    // コーディネート相談申込フォームのURL
    if (url.pathname.includes('/contact-coordinate') ||
        url.pathname.includes('/reservation-unico-adviser')
      ) {
      this.coordinate(form, url);
    }

    // コーディネート相談申込フォームとカーテン相談申込フォーム
    if (url.pathname.includes('/contact-coordinate') ||
        url.pathname === '/pages/contact-curtain'
      ) {
      this.removeRequiredText(form, requiredText);
    }

    // コーディネート相談申込フォームと店舗のお問い合わせ
    if (url.pathname.includes('/contact-coordinate') ||
        url.pathname.includes('/contact-store') ||
        url.pathname.includes('/contact-repair') ||
        url.pathname.includes('/contact-customize') ||
        url.pathname.includes('/contact-buy-parts') ||
        url.pathname === '/pages/contact-curtain'
      ) {
      // ご希望の店舗選択時の処理
      this.inputSendMailAddress(form);
    }

    // サンプル申込フォーム
    // サンプル申込フォーム（カーテン・家具）のURL
    if (url.pathname.includes('/contact-curtain-sample') || url.pathname.includes('/contact-furniture-sample')) {
      const type = url.pathname.includes('/contact-curtain-sample') ? 'curtain' : 'furniture';
      const localStorageKey = type === 'curtain' ? 'curtainSampleRequest' : 'furnitureSampleRequest';
      const labelText = type === 'curtain' ? 'カーテンサンプル' : '家具サンプル';
      this.sampleRequest(form, type, localStorageKey, labelText);
    }

    // アフターサービス系のフォーム
    if (url.pathname.includes('/contact-repair') || url.pathname.includes('/contact-customize') || url.pathname.includes('/contact-buy-parts')) {
      // プログレスバーの非表示
      const progressBar = form.querySelector('.wizard__header');
      if (progressBar) {
        progressBar.style.display = 'none';
        const panels = form.querySelectorAll('.panel');
        panels.forEach(panel => {
          panel.style.paddingTop = '0';
        });
      }
    }

    // 郵便番号の入力
    if(form.querySelector('.zipcode')) {
      this.getAddress(form);
    }

    // 送信後にトップまでスクロール
    document.addEventListener("globo.formbuilder.form.submitted", function(e){
      setTimeout(() => {
        const mainContent = document.querySelector('#MainContent');
        if (mainContent) {
          mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 200);
    });

    const thumbs = form.querySelectorAll('.unico-pfb-image-option.columns-2 .gfb__image-option__wrapper .gfb__image-option__thumb');
    thumbs.forEach(thumb => {
      if (thumb.querySelector('svg')) {
        thumb.style.display = 'none';
      }
    });

    document.addEventListener("globo.formbuilder.form.beforeMoveStep", function(e){
      if(!document.querySelector('.panel.movingIn').classList.contains('errors')) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      }
    });

    document.addEventListener("click", function(e) {
      if (e.target.classList.contains('action') && e.target.classList.contains('previous')) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      }
    });
  },

  productInit: function() {
    document.addEventListener('click', function(event) {
      if (!event.target.closest('#sample-request')) return;
      event.preventDefault();

      const sampleRequest = document.querySelector('#sample-request');
      const id = sampleRequest.getAttribute('data-id');
      const type = sampleRequest.getAttribute('data-type');
      const sku = sampleRequest.getAttribute('data-sku');
      const model = sampleRequest.getAttribute('data-model');
      const title = sampleRequest.getAttribute('data-title');
      const image = sampleRequest.getAttribute('data-image');
      const url = sampleRequest.getAttribute('data-url');
      const price = sampleRequest.getAttribute('data-price');

      if(type === 'curtain') {
        const curtainLocalStorage = JSON.parse(localStorage.getItem('curtainSampleRequest') ? localStorage.getItem('curtainSampleRequest') : '{}');
        if(!curtainLocalStorage[id]) {
          curtainLocalStorage[id] = {
            sku: sku,
            model: model,
            title: title,
            image: image,
            date: new Date().getTime(),
            url: url,
            price: price
          };
          localStorage.setItem('curtainSampleRequest', JSON.stringify(curtainLocalStorage));
        }

      } else if (type === 'furniture') {
        const furnitureLocalStorage = JSON.parse(localStorage.getItem('furnitureSampleRequest') ? localStorage.getItem('furnitureSampleRequest') : '{}');
        if(!furnitureLocalStorage[id]) {
          furnitureLocalStorage[id] = {
            sku: sku,
            title: title,
            image: image,
            date: new Date().getTime(),
            url: url,
            price: price
          };
          localStorage.setItem('furnitureSampleRequest', JSON.stringify(furnitureLocalStorage));
        }
      }

      // 無料サンプルご希望商品ページのURL
      location.href=`/pages/sample-list?type=${type}`;
    });
  },

  replaceRequired: function(form, requiredText = '必須') {
    // *を「必須に置き換える」
    const requiredItems = form.querySelectorAll('.text-danger.text-smaller');
    requiredItems.forEach(function(item) {
      if(item.closest('[data-type="acceptTerms"]')) {
        item.remove();
      } else {
        item.innerHTML = requiredText;
      }
    });

  },

  checkMailAddress: function(form) {
    const submitButton = form.querySelector('button[type="submit"]');
    submitButton.disabled = true;

    const mailAddress = form.querySelector('.unico-pfb-mail input[type="text"]');
    const confirmMailBox = form.querySelector('.unico-pfb-mail-confirm');
    const confirmMailAddress = confirmMailBox.querySelector('.unico-pfb-mail-confirm input[type="text"]');
    mailAddress.addEventListener('input', function() {
      if (mailAddress.value === confirmMailAddress.value) {
        submitButton.disabled = false;
        confirmMailBox.classList.remove('has-error');
        confirmMailBox.classList.add('has-success');
      } else {
        submitButton.disabled = true;
        confirmMailBox.classList.remove('has-success');
        confirmMailBox.classList.add('has-error');
      }
    });
    confirmMailAddress.addEventListener('input', function() {
      if (mailAddress.value === confirmMailAddress.value) {
        submitButton.disabled = false;
        confirmMailBox.classList.remove('has-error');
        confirmMailBox.classList.add('has-success');
      } else {
        submitButton.disabled = true;
        confirmMailBox.classList.remove('has-success');
        confirmMailBox.classList.add('has-error');
      }
    });
  },

  underButton: function(form) {
    const underButtonElement = form.querySelector('.under-button');
    if (!underButtonElement) return;
    const stepNumber = underButtonElement.className.match(/step-(\d+)/)[1];
    const panel = form.querySelector(`.panel[data-step="${stepNumber}"]`);

    if (!panel.classList.contains('movingIn')) {
      underButtonElement.style.display = 'none';
      return;
    }

    const targetElement = form.querySelector('.gfb__footer');

    if (underButtonElement && targetElement) {
      targetElement.insertAdjacentElement('afterend', underButtonElement);
      underButtonElement.style.display = 'block';
    }
  },

  coordinate: function(form, url) {
    const params = url.searchParams;
    const q1 = params.get('q1');

    if(q1) {
      const q1Input = form.querySelectorAll('.unico-pfb-coordinate-q1 .globo-form-input .radio-input');
      q1Input.forEach(function(input, index) {
        if ((index + 1) === parseInt(q1)) {
          input.checked = true;
          const submitBotton = form.querySelector('.action.submit');
          submitBotton.click();
        }
      });
    }

      document.querySelector(".globo-formbuilder").insertAdjacentHTML(
      'beforeend',
      `
        <div class="unico-button-area -type-vertical" style="display:none;">
          <button class="unico-button -type-square" data-modal-target="modal-01" id="cordinate-confirm">確認</button>
        </div>
        <unico-modal data-target-id="modal-01" data-modal-mode="alert">
          <dialog class="unico-u-pb-20">
            <div class="unico-modal-content">
              <div class="unico-modal-content-section">
                <p class="unico-modal-lead-text">当社商品の購入を検討されているお客様へ向けたサービスとなります。<br>※お手持ちの家具や他社商品のみのご相談はサービス対象外です。</p>
                <div class="unico-button-area -type-vertical">
                  <button class="unico-button -type-square -color-dark" data-target-id="modal-close-button" data-modal-confirm="dismiss">続ける</button>
                </div>
              </div>
            </div>
          </dialog>
        </unico-modal>
      `
    );

    const cordinateConfirm = document.querySelector('#cordinate-confirm');
    cordinateConfirm.click();
  },

  // 「必須」削除
  removeRequiredText: function(form, requiredText = '必須') {
    const requiredItems = form.querySelectorAll('.text-danger.text-smaller');
    requiredItems.forEach(function(item) {
      if (!item.closest('.unico-qa-form-field')) return;
      if(item.innerHTML.includes(requiredText)) {
        item.remove();
      }
    });
  },

  inputSendMailAddress: function(form) {
    const storeSelectInput = form.querySelector('.select-store select');
    if (!storeSelectInput) return;
    storeSelectInput.addEventListener('change', function(e) {
      const value = e.target.value;
      const storeData = document.querySelector('#store-list');
      const storeDataJson = JSON.parse(storeData.innerHTML);
      const storeMail = storeDataJson[value];
      const storeMailInput = form.querySelector('.select-store-mail input');
      storeMailInput.value = storeMail;
    });
  },

  sampleRequest: function(form, type, localStorageKey, labelText) {
    const localStorageData = JSON.parse(localStorage.getItem(localStorageKey) ? localStorage.getItem(localStorageKey) : '{}');
    if(Object.keys(localStorageData).length === 0) return;

    
    
    const sortedLocalStorageData = Object.keys(localStorageData).sort((a, b) => {
      return localStorageData[a].date - localStorageData[b].date;
    });

    const sampleRequestList = form.querySelectorAll('.unico-pfb-sample');
    sampleRequestList.forEach(function(sampleRequest, index) {
      const imageLink = sampleRequest.querySelector('.unico-pfb-sample__image-link');
      const img = sampleRequest.querySelector('.unico-pfb-sample__image');
      const link = sampleRequest.querySelector('.unico-pfb-sample__link');
      const dataLabel = sampleRequest.closest('[data-type="html"]').nextElementSibling.querySelector(`[data-label="${labelText}${index + 1}"]`);
      const hiddenInput = dataLabel.closest('div').querySelector('input[type="hidden"]');
      const optionHiddenInput = type === 'furniture' ? dataLabel.closest('div').nextElementSibling.querySelector('input[type="hidden"]') : null;

      if(!localStorageData[sortedLocalStorageData[index]]) {
        sampleRequest.style.display = 'none';
        return;
      };

      imageLink.href = localStorageData[sortedLocalStorageData[index]].url;
      img.src = localStorageData[sortedLocalStorageData[index]].image;
      link.href = localStorageData[sortedLocalStorageData[index]].url;
      link.innerHTML = `${localStorageData[sortedLocalStorageData[index]].title}${localStorageData[sortedLocalStorageData[index]].type ? `<br>タイプ：${localStorageData[sortedLocalStorageData[index]].type}` : ''}`;
      hiddenInput.value = `${localStorageData[sortedLocalStorageData[index]].title} `;
      if(type === 'curtain') {
        hiddenInput.value += `（型番：${localStorageData[sortedLocalStorageData[index]].model}）`;
      }
      if(type === 'furniture' && localStorageData[sortedLocalStorageData[index]].type && optionHiddenInput) {
        optionHiddenInput.value = `${localStorageData[sortedLocalStorageData[index]].type}`;
      }
    });

    document.addEventListener("globo.formbuilder.form.submitted", function(e){
      localStorage.removeItem(localStorageKey);
    });
  },

  getAddress: function(form) {
    const zipcodeField = form.querySelector('.zipcode input[type="text"]');
    zipcodeField.addEventListener('blur', (event) => {
      const zipcode = event.target.value;
      const url = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`;

      fetch(url)
      .then(response => response.json())
      .then(data => {
        const url = new URL(window.location.href);

        if (url.pathname.includes('/contact-coordinate') ||
            url.pathname === '/pages/contact-curtain'
          ) {
          const prefectureAndCityInput = form.querySelector('.prefecture input[type="text"]');
          if(prefectureAndCityInput) {
            prefectureAndCityInput.value = data.results[0].address1 + data.results[0].address2;
          }

          const addressInput = form.querySelector('.street input[type="text"]');
          if(addressInput) {
            addressInput.value = data.results[0].address3;
          }

        } else {
          const prefectureSelect = form.querySelector('.prefecture select');
          if(prefectureSelect) {
            prefectureSelect.value = data.results[0].address1;
          }
  
          const cityInput = form.querySelector('.city input[type="text"]');
          if(cityInput) {
            cityInput.value = data.results[0].address2;
          }
  
          const addressInput = form.querySelector('.street input[type="text"]');
          if(addressInput) {
            addressInput.value = data.results[0].address3;
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  }
};

window.WLPowerfulFormBuilder = WLPowerfulFormBuilder;
document.addEventListener("globo.formbuilder.form.loaded", function(e){
  WLPowerfulFormBuilder.init(e.detail.form);
});
document.addEventListener("DOMContentLoaded", function(){
  const sampleRequest = document.querySelector('#sample-request');
  if(sampleRequest) {
    WLPowerfulFormBuilder.productInit();
  }
});